import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Avatar,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { updatePaymentStatus } from "../../api/api";
import { useEffect } from "react";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { data } = useParams(); // base64 encoded string
  let decodedData = {};

  try {
    decodedData = JSON.parse(atob(data)); // decode + parse JSON
    console.log("Decoded Data:", decodedData);
    
    
  } catch (err) {
    console.error("Error decoding data:", err);
  }

  const status = decodedData.STATUS;
  const orderId = decodedData.ORDERID;
  const txnId = decodedData.TXNID;
  const amount = decodedData.TXNAMOUNT;
  const date = decodedData.TXNDATE;
  const gatewayName = decodedData.GATEWAYNAME;
  const bankTxnId = decodedData.BANKTXNID;

  const isSuccess = status === "TXN_SUCCESS";


  const handleBackToReports = () => {
    navigate("/view-reports");
  }

  const handleUpdatePayment = async () => {
    try {
    const payment_userId = localStorage.getItem("payment_user_id");
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        Transaction_id: decodedData.TXNID,
         Bill_id: decodedData.ORDERID,
        Amount: decodedData.TXNAMOUNT,
        Payment_Type:decodedData.PAYMENTMODE,
        CenterID:'',
        Appoinment_id:'',
        user_id:payment_userId,
        Amount:decodedData.TXNAMOUNT,
        Transaction_date:decodedData.TXNDATE,
        Transaction_status:decodedData.STATUS,
        


      }

      
        const response = await updatePaymentStatus(payload);
        console.log(response);
        localStorage.removeItem("payment_user_id");
        

    }
    catch (error) {
      console.error("Error updating payment status:", error);
    } 
  }


  useEffect(() => {
    if (isSuccess) {
      handleUpdatePayment();
    }
  }, [isSuccess]); 

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
    >
      <Card sx={{ maxWidth: 750, width: "100%", borderRadius: 3, boxShadow: 4 }}>
        {/* Header */}
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        //   bgcolor={isSuccess ? "success.main" : "error.main"}
          color="white"
          py={4}
          style={{ backgroundColor: isSuccess ? "#0FB7A4" : "#D32F2F" }}
        >
          <Avatar
            sx={{
              bgcolor: "white",
              width: 60,
              height: 60,
              mb: 2,
            }}
          >
            {isSuccess ? (
              <CheckCircleIcon style={{color:'#0FB7A4'}} fontSize="large" />
            ) : (
              <CancelIcon color="error" fontSize="large" />
            )}
          </Avatar>
          <Typography variant="h6" fontWeight="bold">
            Payment {isSuccess ? "Success !" : "Failed ❌"}
          </Typography>
        </Box>

        {/* Body */}
        <CardContent style={{backgroundColor: '#d9f2efff'}}>
          <Table>
            <TableBody >
              <TableRow>
                <TableCell sx={{ fontWeight: "bold",color:'grey' }}>TXNID :</TableCell>
                <TableCell style={{color:'grey'}}>{txnId}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold",color:'grey' }}>TXNDATE :</TableCell>
                <TableCell style={{color:'grey'}}>{date}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold",color:'grey' }}>TXNAMOUNT :</TableCell>
                <TableCell style={{color:'grey'}}>{amount}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold",color:'grey' }}>STATUS :</TableCell>
                <TableCell style={{color:'grey'}}>{status}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold",color:'grey' }}>ORDERID :</TableCell>
                <TableCell style={{color:'grey'}}>{orderId}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold",color:'grey' }}>BANKTXNID :</TableCell>
                <TableCell style={{color:'grey'}}>{bankTxnId}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold",color:'grey' }}>GATEWAYNAME :</TableCell>
                <TableCell style={{color:'grey'}}>{gatewayName}</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          {/* Button */}
          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
            //   color={isSuccess ? "success" : "error"}
            style={{ backgroundColor: isSuccess ? "#0FB7A4" : "#D32F2F" }}
              sx={{ borderRadius: "20px", px: 4 }}
              onClick={handleBackToReports}
            >
              Go back
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentSuccess;
